import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const AdminRoute = ({ children }) => {
	const { isLoggedIn, isLoading, userRole } = useAuth();

	if (isLoading) {
		return (
			<div
				style={{
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					height: '100vh',
				}}
			>
				<p>Laster...</p>
			</div>
		);
	}

	if (!isLoggedIn) {
		return <Navigate to='/login' />;
	}

	if (!['admin', 'superAdmin'].includes(userRole)) {
		return <Navigate to='/' />;
	}

	return children;
};

export default AdminRoute;
